import { render } from "./TemplateBook.vue?vue&type=template&id=36eb8b2a"
import script from "./TemplateBook.vue?vue&type=script&lang=js"
export * from "./TemplateBook.vue?vue&type=script&lang=js"
script.render = render

export default script